<div class="nsw-accordion js-accordion ready full-width" style="width:100%;">   
    <div class="nsw-accordion__title">
        <button type="button" 
            class="nsw-accordion__button"    
            [class.active]="expanded"
            [attr.aria-expanded]="expanded" 
            [attr.aria-controls]="accordionId"                        
            (click)="onAccordionButtonClicked($event)">
            {{title}}
            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">keyboard_arrow_down</span>
        </button>
    </div>
    <div class="nsw-accordion__content" [id]="accordionId" 
        [attr.hidden]="!expanded ? '' : null">
        <ng-content></ng-content>        
    </div>
</div>